import {Container, Text} from '@inlet/react-pixi';
import {CheatTextInput} from '../../components/CheatTextInput';
import React from 'react';

type InputFieldProps = {
    value: string;
    title: string;
    width?: number;
    onChange: (value: string) => void;
    isInvalid?: boolean;
    placeholder?: string;
};

export function InputField(props: InputFieldProps): JSX.Element {
    const {value, placeholder, onChange, isInvalid, title, width = 1000} = props;

    return (
        <Container>
            <Text x={width / 2} text={title} style={{fontSize: 80, fill: 0xffffff, align: 'center'}} anchor={0.5} />
            <CheatTextInput
                y={80}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                isInvalid={isInvalid}
                width={width}
            />
        </Container>
    );
}
